import React from 'react';
import { BoxIcon } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
}
export function ServiceCard({
  title,
  description,
  icon: Icon
}: ServiceCardProps) {
  return <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow group" data-id="element-207">
      <div className="bg-gray-900 text-amber-400 p-3 rounded-lg inline-block mb-4 group-hover:bg-amber-500 group-hover:text-white transition-colors" data-id="element-208">
        <Icon size={28} data-id="element-209" />
      </div>
      <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-210">{title}</h3>
      <p className="text-gray-700" data-id="element-211">{description}</p>
    </div>;
}